import React, { useState, useEffect } from "react";
import { Link } from "react-scroll";
import { useSearchParams } from "react-router-dom";
import * as Icon from "react-feather";

// Import components
import Navbar from "../component/Navbar";
import Footer2 from "../component/Footer2";

import { policies } from "../constants/policies";

export default function Policies() {
  const [isOpen, setMenu] = useState(true);
  const [activeTab, setActiveTab] = useState("privacy");
  const [searchParams] = useSearchParams();

  // Handle URL parameters for direct tab navigation
  useEffect(() => {
    const tabParam = searchParams.get("tab");
    if (
      tabParam &&
      ["privacy", "cookies", "terms", "refund"].includes(tabParam)
    ) {
      setActiveTab(tabParam);
    }

    // Scroll to top when navigating to policies page
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [searchParams]);

  // Always show navbar with sticky styling on policies page
  useEffect(() => {
    const navbar = document.getElementById("navbar");
    if (navbar) {
      navbar.classList.add("nav-sticky");
    }
  }, []);

  window.addEventListener("scroll", windowScroll);

  /**
   * Window scroll
   */
  function windowScroll() {
    const mybutton = document.getElementById("back-to-top");

    if (
      document.body.scrollTop >= 500 ||
      document.documentElement.scrollTop >= 500
    ) {
      mybutton.classList.add("block");
    } else {
      mybutton.classList.add("none");
    }
  }

  const toggleMenu = () => {
    setMenu(!isOpen);
  };

  return (
    <>
      <div>
        <Navbar isOpen={isOpen} toggleMenu={toggleMenu} showNavLinks={false} />

        {/* Page Header */}
        <section className="bg-light pb-5 pt-10">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-8 text-center">
                <h1 className="fw-bold text-dark mb-3">Legal Policies</h1>
                <p className="text-muted mb-0">
                  Important information about how we handle your data and our
                  terms of service
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Policies Content */}
        <section className="py-5">
          <div className="container">
            <div className="row">
              {/* Policy Navigation */}
              <div className="col-lg-3 mb-4">
                <div className="card border-0 shadow-sm">
                  <div className="card-body">
                    <h5 className="card-title mb-3">Policies</h5>
                    <nav className="nav flex-column">
                      {Object.keys(policies).map((key) => (
                        <button
                          key={key}
                          className={`nav-link text-start border-0 bg-transparent ${
                            activeTab === key ? "active fw-bold" : "text-muted"
                          }`}
                          onClick={() => setActiveTab(key)}
                        >
                          {policies[key].title}
                        </button>
                      ))}
                    </nav>
                  </div>
                </div>
              </div>

              {/* Policy Content */}
              <div className="col-lg-9">
                <div className="card border-0 shadow-sm">
                  <div className="card-body p-4">
                    <div className="d-flex justify-content-between align-items-center mb-4">
                      <h2 className="card-title mb-0">
                        {policies[activeTab].title}
                      </h2>
                      <small className="text-muted">
                        Last updated: {policies[activeTab].lastUpdated}
                      </small>
                    </div>

                    <div className="policy-content">
                      {policies[activeTab].content.map((item, index) => (
                        <div key={index} className="mb-4">
                          <h5 className="text-dark mb-3">{item.section}</h5>
                          {item.text.split("\n\n").map((para, idx) => (
                            <p key={idx} className="text-muted mb-0">
                              {para.split("\n").map((line, lidx) => {
                                const match = line.match(/^(.*?:)(.*)$/);
                                if (match) {
                                  return (
                                    <span key={lidx}>
                                      <strong>{match[1]}</strong>
                                      {match[2]}
                                      <br />
                                    </span>
                                  );
                                }
                                return (
                                  <span key={lidx}>
                                    {line}
                                    <br />
                                  </span>
                                );
                              })}
                            </p>
                          ))}
                        </div>
                      ))}
                    </div>

                    <hr className="my-4" />

                    <div className="text-center">
                      <p className="text-muted mb-2">
                        If you have any questions about our policies, please
                        contact us:
                      </p>
                      <div className="d-flex justify-content-center gap-3">
                        <a
                          href="mailto:dpo@numantratech.ai"
                          className="btn btn-primary btn-sm"
                        >
                          <Icon.Mail className="fea icon-sm me-1" />
                          Email Us
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Footer2 />

        {/* Back to top */}
        <Link
          to="home"
          id="back-to-top"
          className="back-to-top rounded-pill fs-5"
        >
          <Icon.ArrowUp className="fea icon-sm icons align-middle" />
        </Link>
      </div>
    </>
  );
}
